import React from 'react';

import classNames from 'classnames/bind';
import style from './ParagraphWithImage.scss';
const ctx = classNames.bind(style);

import ArticleSpreader from '../ArticleSpreader';
import Paragraph from '../Paragraph';

const ParagraphWithImage = props => (
  <div className={ctx('container')}>
    <div className={ctx('background')} />
    <ArticleSpreader>
      <div className={ctx('inner')}>
        <div className={ctx('shadow')}>
          <img src={props.image} className={ctx('image')} />
        </div>
        <Paragraph>{props.children}</Paragraph>
      </div>
    </ArticleSpreader>
  </div>
);

export default ParagraphWithImage;
